// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Nav {
    background: #38514C;
    height: 80px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    flex-wrap: wrap;
}


.forest_img{
    width: 56px;
    height: 56px;
}
.forest_img_2{
    width: 210px;
    height: 56px;
}

.forest_img_2{
    width: 210px;
    height: 56px;
}

.Nav_item1{
    display: flex;
    align-items: center;
    gap:20px;
    list-style-type: none;
}

.Nav_item1_text>span{
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    width: 300px;
    color: #FFFF;
    display: inline-block;
    margin-bottom: 10px;
}



.Nav_item2{
    display: flex;
    flex-direction: rpw;
    align-items: center;
    list-style-type: none;
    gap :-10px;
}

.Nav_item2_text > span {
    font-weight: 200;
    font-size: 16.5px;
    line-height: 24px;
    width: 100px;
    color: #FFFF;
    display: inline-block;
    margin-right: -20px;
}

.Nav_item2{
    display: flex;
    flex-direction: rpw;
    align-items: center;
    list-style-type: none;
    gap :-10px;
}

.Nav_item2_text > span {
    font-weight: 200;
    font-size: 16.5px;
    line-height: 24px;
    width: 100px;
    color: #FFFF;
    display: inline-block;
    margin-right: -20px;
}

.menu {
    display: none;
}

.Nav_Drop_Down{
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 12px 16px;
    gap: 12px;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    cursor: pointer;
}

.Nav_Drop_Down>span{
    color: #FFFF;
    width: 49px;
    height: 20px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/CSS/Navigation.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,eAAe;AACnB;;;AAGA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;AACvB;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".Nav {\n    background: #38514C;\n    height: 80px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 1rem;\n    flex-wrap: wrap;\n}\n\n\n.forest_img{\n    width: 56px;\n    height: 56px;\n}\n.forest_img_2{\n    width: 210px;\n    height: 56px;\n}\n\n.forest_img_2{\n    width: 210px;\n    height: 56px;\n}\n\n.Nav_item1{\n    display: flex;\n    align-items: center;\n    gap:20px;\n    list-style-type: none;\n}\n\n.Nav_item1_text>span{\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    width: 300px;\n    color: #FFFF;\n    display: inline-block;\n    margin-bottom: 10px;\n}\n\n\n\n.Nav_item2{\n    display: flex;\n    flex-direction: rpw;\n    align-items: center;\n    list-style-type: none;\n    gap :-10px;\n}\n\n.Nav_item2_text > span {\n    font-weight: 200;\n    font-size: 16.5px;\n    line-height: 24px;\n    width: 100px;\n    color: #FFFF;\n    display: inline-block;\n    margin-right: -20px;\n}\n\n.Nav_item2{\n    display: flex;\n    flex-direction: rpw;\n    align-items: center;\n    list-style-type: none;\n    gap :-10px;\n}\n\n.Nav_item2_text > span {\n    font-weight: 200;\n    font-size: 16.5px;\n    line-height: 24px;\n    width: 100px;\n    color: #FFFF;\n    display: inline-block;\n    margin-right: -20px;\n}\n\n.menu {\n    display: none;\n}\n\n.Nav_Drop_Down{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 12px 16px;\n    gap: 12px;\n    background-color: rgba(0, 0, 0, 0.2);\n    border-radius: 8px;\n    cursor: pointer;\n}\n\n.Nav_Drop_Down>span{\n    color: #FFFF;\n    width: 49px;\n    height: 20px;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
